export default __webpack_public_path__ + "static/media/rabbitboard.7101d7b5.png";